import API from 'aurora-api';
import * as urls from 'aurora-api/urls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;

const api = new API(BASE_URL);

class MusatahaService {
  static registerApplication = data => api.post(urls.WORKFLOW.REGISTER_APPLICATION, data);

  static fetchMusatahaApplication = id => api.get(urls.WORKFLOW.FETCH_APPLICATION, id);

  static fetchWaiveOfApplication = id => api.get(urls.SELLPURCHASE.FETCH_APPLICATION_WAIVE_MUSATAHA, id);

  static fectBuyer = id => api.get(urls.SELLPURCHASE.FETCH_APPLICATION_WAIVE_MUSATAHA, id);

  static saveApplication = payload => api.post(urls.SELLPURCHASE.SAVE_APPLICATION_MUSATAHA_WAIVER, payload);

  // static submitWorkflow = (data, url) => api.post(url, data);

  static fetchContract = id => api.get(urls.MUSATAHA.GET_MUSATAHA_APPLICATION_CONTRACT, id);

  static getPaymentBreakdown = (body, id) => api.post(urls.MUSATAHA.MUSATAHA_PAYMENT_BREATDOWN, body, null, id);

  static saveMusatahaApplication = data => api.post(urls.MUSATAHA.SAVE_MUSATAHA_APPLICATION, data);

  static checkoutMusatahaApplication = data => api.post(urls.MUSATAHA.CHECKOUT_MUSATAHA_APPLICATION + '/' + data);

  static checkoutMusatahaApplicationWaive = id =>
    api.post(urls.MUSATAHA.CHECKOUT_MUSATAHA_APPLICATION_WAIVE + '/' + id);

  static getApplicationPDFApp = appId => {
    const downloadAPI = new API(`${BASE_URL}`, null, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      responseType: 'blob',
    });
    return downloadAPI.get(urls.MUSATAHA.APPLICATION_PDF, appId);
  };

  static getApplicationPDFAppTenant = appId => {
    const downloadAPI = new API(`${BASE_URL}`, null, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      responseType: 'blob',
    });
    return downloadAPI.get(urls.MUSATAHA.APPLICATION_PDF_TENANT, appId);
  };

  static approveMusatahaApplication = data => api.post(urls.MUSATAHA.APPROVE_MUSATAHA_APPLICATION, data);

  static buyerApproveMusatahaWaiver = data => api.post(urls.MUSATAHA.BUYER_APPROVE_MUSATAHA, data);

  static sellerApproveMusatahaWaiver = data => api.post(urls.MUSATAHA.OWNER_APPROVE_MUSATAHA, data);

  static getPaymentBreakdownWaiver = id => api.get(urls.MUSATAHA.MUSATAHA_PAYMENT_BREATDOWN_WAIVER, id);

  static getApplicationPDFApp = appId => {
    const downloadAPI = new API(`${BASE_URL}`, null, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      responseType: 'blob',
    });
    return downloadAPI.get(urls.MUSATAHA.APPLICATION_PDF, appId);
  };

  static getMusatahaApplicationPDFApp = appId => {
    const downloadAPI = new API(`${BASE_URL}`, null, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      responseType: 'blob',
    });
    return downloadAPI.get(urls.MUSATAHA.MUSATAHA_APPLICATION_PDF, appId);
  };

  static getPropertyDocuments = data => api.get(urls.MUSATAHA.MUSATAHA_PROPERTY_DOCUMENTS, null, data);
}

export default MusatahaService;
